import { render, staticRenderFns } from "./updatePhone.vue?vue&type=template&id=11385a33&scoped=true&"
import script from "./updatePhone.vue?vue&type=script&lang=js&"
export * from "./updatePhone.vue?vue&type=script&lang=js&"
import style0 from "./updatePhone.vue?vue&type=style&index=0&id=11385a33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11385a33",
  null
  
)

export default component.exports